
export type UserProfileUpdateRequestSocialLinks = {
  github?: string;
  linkedin?: string;
  twitter?: string;
};
